export enum ErrorStateType {
  ValidationFailure = 'ValidationFailure',
  MissingParameters = 'MissingParameters',
  InvalidTOS = 'InvalidTOS',
}